import type {EditRepresentativeNoteFormPayload} from "./edit-representative-note.schema";

import {editRepresentativeNote} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {representativeKeys, representativeMutationKeys} from "../../../../../representative-keys";

export function editRepresentativeNoteMutationOptions(representativeId: string, noteId: number) {
  return mutationOptions({
    mutationKey: representativeMutationKeys.editRepresentativeNote,
    mutationFn: (formPayload: EditRepresentativeNoteFormPayload) =>
      editRepresentativeNote(representativeId, noteId, formPayload),
    onSuccess: async (_result, _formPayload, _onMutateResult, {client}) => {
      await client.invalidateQueries({queryKey: representativeKeys.detail(representativeId)});
    },
  });
}
